export const TITLE = 'Product View (WIP)';
export const TRADITIONAL_TITLE = 'Traditional Vendors assigned for Automatic Delivery';
export const POD_TITLE = 'POD Vendors assigned for Automatic Delivery';
export const NOTE = 'Note: If you would like to unassign this ISBN from specific printer or add a new printer for auto delivery and updates please go to ';
export const NOTE_LINK = 'Printer Assignment';
